<style lang="sass" scoped>
.title_top
  text-align: center
  padding: 15px

.border
  border: 3px solid #e8ab77 !important
  padding: 10px
  margin-bottom: 20px

.special_border
  padding: 0

.special_title
  padding: 10px 0
  padding-left: 10px

.p_l
  padding-left: 30px

.adjust
  display: flex

  .inner_cure
    flex: 1
    margin-right: 20px

  .outer_cure
    flex: 1

.sub_title
  font-size: 15px
  padding-bottom: 20px
  font-weight: bold

.adjust_title
  padding-top: 52px

.adjust_solution
  margin-bottom: 20px
</style>

<template>
  <div class="print_report_container">
    <el-button class="print_btn" size="large" type="primary" @click="print"
      >打印</el-button
    >
    <h1 class="title_top">体质体格评测报告单</h1>
    <div v-if="diseaseInfo" :class="['myinfo', 'my_info', 'border']">
      <div class="user_info">
        <div class="myinfo_text">
          <span :class="['certain_width']">
            <span :class="['bold_color']">宝宝</span>
            <span>{{ userInfo.user.child_name }}</span>
          </span>
        </div>
        <span :class="['bold_color']">性别</span>
        <span>{{ userInfo.user.sex }}</span>
        <div class="myinfo_text">
          <span class="certain_width">
            <span :class="['bold_color']">年龄</span>
            <span>{{ userInfo.user.age }}</span>
          </span>
        </div>
        <span class="flex_1">
          <span :class="['bold_color']">结果</span>
          <span>{{
            diseaseInfo.face_result || diseaseInfo.disease_name || '无'
          }}</span>
        </span>
        <div>
          <span :class="['bold_color']">症状</span>
          <span>{{ diseaseInfo.symptom_str || '无' }}</span>
        </div>
        <div>
          <span :class="['bold_color']">症状备注</span>
          <span>{{ diseaseInfo.symptom_remark || '无' }}</span>
        </div>
      </div>
    </div>
    <div v-else :class="['myinfo', 'no_disease', 'border', 'p_l']">
      <div class="myinfo_text">
        <span :class="['certain_width_block']"
          >宝宝：{{ userInfo.user.child_name }}</span
        >
        <span>年龄：{{ userInfo.user.age }}</span>
      </div>
      <div class="myinfo_text">
        <span :class="['certain_width_block']"
          >性别：{{ userInfo.user.sex }}</span
        >
        <span>电话：{{ babyInfo.user.parent_tel }}</span>
      </div>
    </div>
    <div class="content">
      <div :class="{hide: noPhysicalImg}" class="content_items border">
        <div class="title">
          体质评测结果分析
          <div
            style="float: right;font-size: 14px;font-weight: normal;color: black;"
          >
            评测时间:{{ babyInfo.user_info.create_date }}
          </div>
        </div>
        <div class="mid">
          <div class="mid_Imgs">
            <div
              ref="physicalImg"
              class="echarts"
              style="width: 270px; height: 160px;"
            />
          </div>

          <div class="mid_results">
            宝宝体质：
            <span class="num">{{ babyInfo.system.result }}</span>
          </div>
          <div class="mid_details">
            <ul class="ul_items">
              <li class="item">主要特征：{{ babyInfo.system.detail }}</li>
              <li class="item">调养法则：{{ babyInfo.system.rule }}</li>
              <li class="item">
                潜在问题：
                <ol class="items_ol">
                  <li
                    v-for="(item, index) in babyInfo.system.question"
                    :key="index"
                  >
                    <span class="ol_index">{{ index + 1 + '、' }}</span>
                    <span>{{ item }}</span>
                  </li>
                </ol>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div :class="{hide: noHeightImg}" class="content_items border">
        <div class="title">
          身高测量/分析
          <div
            style="float: right;font-size: 14px;font-weight: normal;color: black;"
          >
            评测时间:{{ babyInfo.user_info.create_date }}
          </div>
        </div>
        <div class="mid">
          <div class="mid_Imgs">
            <div
              ref="heightImg"
              class="echarts"
              style="width: 270px; height: 160px;"
            />
          </div>
          <div class="mid_results">
            宝宝身高：
            <span class="num">{{ babyInfo.physique.height.result.num }}</span>
          </div>
          <div class="mid_details">
            <ul class="ul_items">
              <li class="item">评测结果：{{ babyInfo.physique.height.say }}</li>
              <li class="item">
                调养法则：{{ babyInfo.physique.height.rule }}
              </li>
              <li class="item">
                潜在问题：
                <ol class="items_ol">
                  <li
                    v-for="(item, index) in babyInfo.physique.height.question"
                    :key="index"
                  >
                    <span class="ol_index">{{ index + 1 + '、' }}</span>
                    <span>{{ item }}</span>
                  </li>
                </ol>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div :class="{hide: noWeightImg}" class="content_items border">
        <div class="title">
          体重测量/分析
          <div
            style="float: right;font-size: 14px;font-weight: normal;color: black;"
          >
            评测时间:{{ babyInfo.user_info.create_date }}
          </div>
        </div>
        <div class="mid">
          <div class="mid_results">
            宝宝体重：
            <span class="num">{{ babyInfo.physique.weight.result.num }}</span>
          </div>
          <div class="mid_Imgs">
            <div
              ref="weightImg"
              class="echarts"
              style="width: 270px; height: 160px;"
            />
          </div>
          <div class="mid_details">
            <ul class="ul_items">
              <li class="item">评测结果：{{ babyInfo.physique.weight.say }}</li>
              <li class="item">
                调养法则：{{ babyInfo.physique.weight.rule }}
              </li>
              <li class="item">
                潜在问题：
                <ol class="items_ol">
                  <li
                    v-for="(item, index) in babyInfo.physique.weight.question"
                    :key="index"
                  >
                    <span class="ol_index">{{ index + 1 + '、' }}</span>
                    <span>{{ item }}</span>
                  </li>
                </ol>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div v-if="checkbox.solution.solutionProduct" class="content_items">
        <div :class="['mid', 'adjust']">
          <div class="inner_cure border">
            <div class="title adjust_solution">
              解决方案
            </div>
            <div :class="['sub_title', 'colorful']">外调</div>
            <div
              v-if="typeof userInfo.progress.fit_tuina === 'string'"
              class="programme"
            >
              <span class="programme_title">推拿：</span>
              <p class="programme_text">{{ userInfo.progress.fit_tuina }}</p>
            </div>

            <div
              v-else-if="userInfo.progress.fit_tuina.length"
              class="programme"
            >
              <span class="programme_title">推拿：</span>
              <p class="programme_text">
                {{
                  userInfo.progress.fit_tuina.map(e => e.type_name).join('、')
                }}
              </p>
            </div>

            <div v-if="userInfo.progress.stick.length > 0" class="programme">
              <span class="programme_title">贴敷：</span>
              <p
                v-for="(item, index) in userInfo.progress.stick"
                :key="index"
                class="programme_text"
              >
                {{ item.type_name }} -- {{ item.describe }}
              </p>
            </div>

            <div
              v-if="
                userInfo.progress.physical &&
                  userInfo.progress.physical.length > 0
              "
              class="programme"
            >
              <span class="programme_title">理疗：</span>
              <p
                v-for="(item, index) in userInfo.progress.physical"
                :key="index"
                class="programme_text"
              >
                {{ item.type_name }} -- {{ item.describe }}
              </p>
            </div>

            <div
              v-if="
                userInfo.progress.bubble && userInfo.progress.bubble.length > 0
              "
              class="programme"
            >
              <span class="programme_title">泡浴：</span>
              <p
                v-for="(item, index) in userInfo.progress.bubble"
                :key="index"
                class="programme_text"
              >
                {{ item.type_name }} -- {{ item.describe }}
              </p>
            </div>
          </div>
          <div class="outer_cure adjust_title border">
            <div :class="['sub_title', 'colorful']">内服</div>
            <div
              v-if="
                userInfo.progress.nutrition &&
                  userInfo.progress.nutrition.length
              "
              class="programme"
            >
              <span class="programme_title">营养补充：</span>
              <p
                v-for="(item, index) in userInfo.progress.nutrition"
                :key="index"
                class="programme_text"
              >
                {{ item.type_name }} -- {{ item.describe }}
              </p>
            </div>

            <div
              v-if="
                userInfo.progress.medicine && userInfo.progress.medicine.length
              "
              class="programme"
            >
              <span class="programme_title">药食同源：</span>
              <p
                v-for="(item, index) in userInfo.progress.medicine"
                :key="index"
                class="programme_text"
              >
                {{ item.type_name }} -- {{ item.describe }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="checkbox.solution.standardSolution"
        class="content_items border"
      >
        <div class="title">
          标准方案
        </div>
        <div class="mid">
          <div class="programme">
            <div :class="['programme_text', 'flex']">
              <span
                v-for="(item, index) in userInfo.handList.list"
                :key="item.id"
                :class="['item', 'width']"
              >
                <span class="colorful">{{ index + 1 + '、' }}</span
                >{{ item.hand }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="checkbox.solution.fastSolution" class="content_items border">
        <div class="title">
          快捷方案
        </div>
        <div class="mid">
          <div class="programme">
            <div :class="['programme_text', 'flex']">
              <p
                v-for="(item, index) in userInfo.handListSimple.list"
                :key="item.id"
                :class="['item', 'width']"
              >
                <span class="colorful">{{ index + 1 + '、' }}</span
                >{{ item.hand }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="checkbox.solution.foodSolution && userInfo.foodList.length"
        class="content_items border special_border"
      >
        <div class="title special_title">
          食疗方案
        </div>
        <div v-if="userInfo.foodList.length" :class="['mid']">
          <div
            v-for="food in userInfo.foodList"
            :key="food.food"
            class="mid_up"
          >
            <div class="active_p">
              <div>品名：{{ food.food }}</div>
              <div>食材：{{ food.food_detail }}</div>
              <div class="food_menu">
                <span>做法：</span>
                <span class="flex1" v-html="food.food_do" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="checkbox.solution.adjustSolution" class="content_items border">
        <div class="title">
          调护建议
        </div>
        <div v-if="userInfo.progress" class="mid">
          <div
            v-if="userInfo.sayList && userInfo.sayList.length"
            class="programme"
          >
            <div class="programme_text">
              <p
                v-for="(item, index) in userInfo.sayList"
                :key="item.id"
                class="item"
              >
                <span class="colorful">{{ index + 1 + '、' }}</span
                >{{ item.doctor_say }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="checkbox.recommand.recommandProduct"
        class="content_items border"
      >
        <div class="title">
          门店推荐
        </div>
        <div class="mid">
          <div v-if="userInfo.commodity" class="programme">
            <div class="programme_text">
              <p
                v-for="(item, index) in userInfo.commodity.length > 0
                  ? userInfo.commodity
                  : userInfo.product.commodity"
                :key="item.id"
                class="item"
              >
                <span class="colorful">{{ index + 1 + '、' }}</span
                >{{ item.commodity_name }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="checkbox.recommand.productList" class="content_items border">
        <div class="title">
          门店产品
        </div>
        <div class="mid">
          <div v-if="userInfo.product.more" class="programme">
            <div class="programme_text">
              <p
                v-for="(item, index) in userInfo.product.more"
                :key="item.id"
                class="item"
              >
                <span class="colorful">{{ index + 1 + '、' }}</span
                >{{ item.commodity_name }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="checkbox.solution.solutionProduct"
        class="content_items border"
      >
        <div class="title">
          参考文献
        </div>
        <div class="mid">
          <ul class="bookList">
            <li
              v-for="(item, index) in userInfo.progress.book"
              :key="item.id"
              class="item"
            >
              <span class="colorful">{{ index + 1 + '、' }}</span
              >{{ item.from_book }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
import {http} from '@/util';
import url from '@/api/config';

export default {
  props: {
    u_id: [Number, String]
  },

  data() {
    return {
      userInfo: {},
      checkbox: {},
      diseaseInfo: null,
      babyInfo: {
        system: {},
        user: {},
        physique: {
          height: {
            result: {}
          },
          weight: {
            result: {}
          },
          result: {}
        }
      },
      physicalImg: null,
      heightImg: null,
      weightImg: null,
      handList: null,
      handListSimple: null,
      sayList: [],
      foodList: [],
      progress: null,
      productList: [],
      product: null,
      recommendProductId: []
    };
  },

  computed: {
    noPhysicalImg() {
      const res = !(
        this.babyInfo &&
        Boolean(this.physicalImg) &&
        this.checkbox.physique
      );
      return res || this.diseaseInfo;
    },

    noHeightImg() {
      const res = !(
        this.babyInfo &&
        Boolean(this.heightImg) &&
        this.checkbox.physique
      );
      return res || this.diseaseInfo;
    },
    noWeightImg() {
      const res = !(
        this.babyInfo &&
        Boolean(this.weightImg) &&
        this.checkbox.physique
      );
      return res || this.diseaseInfo;
    }
  },

  created() {
    this._getCheckBoxInfo();
    this._getDiseaseInfo();
    this._getUserInfo();
  },

  mounted() {
    this.setTitle();
    this._getCheckBoxInfo();
    this._getDiseaseInfo();
    this._getUserInfo();
    http.post(url.testResult, {u_id: this.u_id}).then(res => {
      this.babyInfo = res;
      if (!this.babyInfo) return;
      this.handList = res.solution.hand;
      this.handListSimple = res.solution.hand_simple;
      this.sayList = res.solution.solution.sayList;
      this.foodList = res.solution.solution.foodList;
      res.solution.solution.book = res.solution.solution.book || [];
      this.progress = res.solution.solution;
      this.recommendProductId = res.product.commodity.map(it => it.id);
      res.product.more = res.product.commodity.concat(res.product.more);
      res.product.more.forEach(it => {
        it.number = 1;
        it.now_price = it.price;
        it.all_price = it.price;
      });
      this.product = res.product.more;
      this.productList = this.product
        .filter(item => this.recommendProductId.includes(item.id))
        .map(item => item.commodity_name);
      this.getCharts();
    });
  },

  methods: {
    setTitle() {
      document.title = 'A5打印';
    },

    _getCheckBoxInfo() {
      const data = localStorage.getItem('checkbox');
      this.checkbox = JSON.parse(data);
    },

    _getDiseaseInfo() {
      const data = localStorage.getItem('diseaseInfo');
      this.diseaseInfo = JSON.parse(data);
    },

    _getUserInfo() {
      const data = localStorage.getItem('userInfo');
      this.userInfo = JSON.parse(data);
    },

    print() {
      window.print();
    },
    getCharts() {
      http.post(url.physicalImg, {u_id: this.u_id}).then(res => {
        console.log(res);
        this.physicalImg = res;
        if (!this.physicalImg) return;
        this.$nextTick(_ => {
          const myChart = echarts.init(this.$refs.physicalImg);
          const option = {
            tooltip: {},
            grid: {
              top: 10,
              bottom: 0,
              left: 0,
              right: 0,
              containLabel: true,
              show: true
            },
            xAxis: {
              data: this.physicalImg.name
            },
            yAxis: {},
            series: [
              {
                name: '体质',
                type: 'bar',
                data: this.physicalImg.grade
              }
            ]
          };
          myChart.setOption(option);
        });
      });

      http.post(url.heightImg, {u_id: this.u_id}).then(res => {
        this.heightImg = res;
        if (!this.heightImg) return;
        const myChart = echarts.init(this.$refs.heightImg);
        const option = {
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            top: 30,
            bottom: 0,
            left: 10,
            right: 20,
            containLabel: true,
            show: true
          },
          legend: {
            top: 0
          },
          xAxis: {
            scale: true,
            name: '月'
            // nameLocation: 'start',
          },
          yAxis: {
            name: '厘米'
          },
          series: [
            {
              name: '标准线',
              symbolSize: 0,
              smooth: true,
              type: 'line',
              data: this.heightImg.data[0].data
            },
            {
              name: '宝宝身高',
              symbolSize: 10,
              itemStyle: {
                normal: {
                  color: '#000',
                  lineStyle: {
                    color: '#000'
                  }
                }
              },
              type: 'scatter',
              data: this.heightImg.data[1].data
            }
          ]
        };
        myChart.setOption(option);
      });
      http.post(url.weightImg, {u_id: this.u_id}).then(res => {
        this.weightImg = res;
        if (!this.weightImg) return;
        const myChart = echarts.init(this.$refs.weightImg);
        const option = {
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            top: 30,
            bottom: 0,
            left: 10,
            right: 20,
            containLabel: true,
            show: true
          },
          legend: {
            top: 0
          },
          xAxis: {
            scale: true,
            name: '月'
            // nameLocation: 'start',
          },
          yAxis: {
            name: '千克'
          },
          series: [
            {
              name: '标准线',
              symbolSize: 0,
              smooth: true,
              type: 'line',
              data: this.weightImg.data[0].data
            },
            {
              name: '宝宝体重',
              symbolSize: 10,
              itemStyle: {
                normal: {
                  color: '#000',
                  lineStyle: {
                    color: '#000'
                  }
                }
              },
              type: 'scatter',
              data: this.weightImg.data[1].data
            }
          ]
        };
        myChart.setOption(option);
      });
    }
  }
};
</script>

<style lang="sass" scoped>
$colorText: #4b90ff

.width
  width: 100%
  text-align: left

.flex
  display: flex
  flex-wrap: wrap

.colorful
  color: $colorText

.my_info
  display: flex
  justify-content: space-between
  height: auto

.flex_1
  flex: 1
  padding-right: 20px

.certain_width
  width: 120px

.certain_width_block
  width: 120px
  display: inline-block
  padding: 10px 0

.bold_color
  color: $colorText
  font-weight: bold
  margin-right: 5px

.no_disease
  flex-direction: column
</style>

<style lang="sass" scoped>
.hide
  visibility: hidden
  display: none

.print_btn
  position: absolute
  right: -80px
  top: 40px

.print_report_container
  position: relative
  margin: 0 auto
  width: 350px
  font-size: 14px
  color: black

  ul li
    list-style: none

  ol
    li
      padding-left: 20px
      position: relative

    .ol_index
      position: absolute
      left: 0

  @media print
    .print_btn
      display: none

  .food_menu
    display: flex

.print_report_container .myinfo
  display: flex

.myinfo
  .user_info
    flex: 1

    &>div
      padding: 5px 0

.content

  .content_items
    width: 100%
    -webkit-print-color-adjust: exact
    page-break-inside: avoid
    box-sizing: border-box

.content_items
  .title
    color: rgb(75, 144, 255)
    font-weight: bold
    font-size: 16px
    margin-bottom: 20px

.mid
  .mid_results .num
    font-size: 14px
    color: rgb(75, 144, 255)

  .programme
    margin-bottom: 23px
    font-size: 14px
    color: black

    .programme_title
      font-size: 14px

    .programme_text
      margin-top: 5px
      line-height: 24px

.content_items .active
  border: 2px dashed rgb(75, 144, 255)
  margin-top: 22px
  margin-bottom: 22px
  margin-right: 20px

  .active_p
    margin: 10px 5px
    line-height: 22px

.mid
  .mid_up
    padding: 10px
    border-bottom: 3px solid #e8ab77

    &:last-child
      border: none

  .bookList
    display: flex
    flex-direction: column
    flex-wrap: wrap

    .item
      margin-top: 10px

  .productList .item
    margin-bottom: 15px

  .mid_details .ul_items .item
    display: flex
    line-height: 22px

.ul_items .items_ol
  flex: 1
</style>
